export { HireAICategory } from "./pages/hireaicategory";
